import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { Typography } from '@/components/ui/typography';

interface TabProps {
  Icon?: React.ComponentType<{ className?: string }>;
  title: string;
  to: string;
  isActive?: boolean;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export function Tab({ Icon, title, to, isActive = false, onClick }: TabProps) {
  return (
    <Link
      to={to}
      onClick={onClick}
      className={clsx(
        'group flex h-10 items-center justify-center gap-1 border-b-2 px-3 py-2',
        'hover:bg-fx-brand-50 hover:border-fx-brand-100',
        { 'border-fx-primary': isActive },
        { 'border-transparent': !isActive },
      )}
    >
      {Icon && (
        <Icon
          className={clsx(
            isActive ? 'text-fx-primary' : 'text-fx-neutral-400',
            'group-hover:text-fx-primary',
          )}
        />
      )}
      <Typography
        variant="text"
        className={clsx(
          !isActive && '!text-fx-neutral-600',
          'group-hover:!text-fx-primary',
        )}
      >
        {title}
      </Typography>
    </Link>
  );
}
